var cov_2puq3ppw12 = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Progress/Circle.tsx",
      hash = "afc95b857bd3cec297be11b4fcf4dbb5c0caecdd",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Progress/Circle.tsx",
    statementMap: {
      "0": {
        start: {
          line: 8,
          column: 21
        },
        end: {
          line: 13,
          column: 1
        }
      },
      "1": {
        start: {
          line: 25,
          column: 6
        },
        end: {
          line: 25,
          column: 11
        }
      },
      "2": {
        start: {
          line: 26,
          column: 20
        },
        end: {
          line: 26,
          column: 96
        }
      },
      "3": {
        start: {
          line: 28,
          column: 12
        },
        end: {
          line: 28,
          column: 55
        }
      },
      "4": {
        start: {
          line: 30,
          column: 12
        },
        end: {
          line: 30,
          column: 27
        }
      },
      "5": {
        start: {
          line: 31,
          column: 20
        },
        end: {
          line: 31,
          column: 64
        }
      },
      "6": {
        start: {
          line: 32,
          column: 16
        },
        end: {
          line: 32,
          column: 73
        }
      },
      "7": {
        start: {
          line: 33,
          column: 16
        },
        end: {
          line: 33,
          column: 78
        }
      },
      "8": {
        start: {
          line: 34,
          column: 19
        },
        end: {
          line: 34,
          column: 53
        }
      },
      "9": {
        start: {
          line: 36,
          column: 2
        },
        end: {
          line: 71,
          column: 3
        }
      },
      "10": {
        start: {
          line: 43,
          column: 16
        },
        end: {
          line: 43,
          column: 71
        }
      },
      "11": {
        start: {
          line: 74,
          column: 0
        },
        end: {
          line: 74,
          column: 34
        }
      }
    },
    fnMap: {
      "0": {
        name: "Circle",
        decl: {
          start: {
            line: 15,
            column: 9
          },
          end: {
            line: 15,
            column: 15
          }
        },
        loc: {
          start: {
            line: 15,
            column: 38
          },
          end: {
            line: 72,
            column: 1
          }
        },
        line: 15
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 42,
            column: 39
          },
          end: {
            line: 42,
            column: 40
          }
        },
        loc: {
          start: {
            line: 43,
            column: 16
          },
          end: {
            line: 43,
            column: 71
          }
        },
        line: 43
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 18,
            column: 4
          },
          end: {
            line: 18,
            column: 42
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 18,
            column: 18
          },
          end: {
            line: 18,
            column: 42
          }
        }],
        line: 18
      },
      "1": {
        loc: {
          start: {
            line: 21,
            column: 4
          },
          end: {
            line: 21,
            column: 28
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 21,
            column: 11
          },
          end: {
            line: 21,
            column: 28
          }
        }],
        line: 21
      },
      "2": {
        loc: {
          start: {
            line: 26,
            column: 61
          },
          end: {
            line: 26,
            column: 77
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 26,
            column: 61
          },
          end: {
            line: 26,
            column: 68
          }
        }, {
          start: {
            line: 26,
            column: 72
          },
          end: {
            line: 26,
            column: 77
          }
        }],
        line: 26
      },
      "3": {
        loc: {
          start: {
            line: 33,
            column: 16
          },
          end: {
            line: 33,
            column: 78
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 33,
            column: 59
          },
          end: {
            line: 33,
            column: 60
          }
        }, {
          start: {
            line: 33,
            column: 63
          },
          end: {
            line: 33,
            column: 78
          }
        }],
        line: 33
      },
      "4": {
        loc: {
          start: {
            line: 33,
            column: 16
          },
          end: {
            line: 33,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 33,
            column: 16
          },
          end: {
            line: 33,
            column: 27
          }
        }, {
          start: {
            line: 33,
            column: 31
          },
          end: {
            line: 33,
            column: 56
          }
        }],
        line: 33
      },
      "5": {
        loc: {
          start: {
            line: 34,
            column: 19
          },
          end: {
            line: 34,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 34,
            column: 19
          },
          end: {
            line: 34,
            column: 24
          }
        }, {
          start: {
            line: 34,
            column: 28
          },
          end: {
            line: 34,
            column: 53
          }
        }],
        line: 34
      },
      "6": {
        loc: {
          start: {
            line: 39,
            column: 9
          },
          end: {
            line: 47,
            column: 16
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 40,
            column: 10
          },
          end: {
            line: 46,
            column: 17
          }
        }, {
          start: {
            line: 47,
            column: 12
          },
          end: {
            line: 47,
            column: 16
          }
        }],
        line: 39
      },
      "7": {
        loc: {
          start: {
            line: 63,
            column: 27
          },
          end: {
            line: 63,
            column: 71
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 63,
            column: 38
          },
          end: {
            line: 63,
            column: 63
          }
        }, {
          start: {
            line: 63,
            column: 66
          },
          end: {
            line: 63,
            column: 71
          }
        }],
        line: 63
      },
      "8": {
        loc: {
          start: {
            line: 69,
            column: 7
          },
          end: {
            line: 69,
            column: 77
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 69,
            column: 7
          },
          end: {
            line: 69,
            column: 15
          }
        }, {
          start: {
            line: 69,
            column: 19
          },
          end: {
            line: 69,
            column: 77
          }
        }],
        line: 69
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Progress/Circle.tsx";
import React from 'react';
import classnames from 'classnames';
import { progressClass } from './styles';
import analyzeColor from './analyzeColor';
import { isRTL } from '../config';
var DefaultValue = (cov_2puq3ppw12.s[0]++, {
  strokeLinecap: 'round',
  strokeWidth: 8,
  size: 100,
  value: 0
});

function Circle(props) {
  var _this = this;

  cov_2puq3ppw12.f[0]++;

  var _ref = (cov_2puq3ppw12.s[1]++, props),
      children = _ref.children,
      _ref$strokeWidth = _ref.strokeWidth,
      strokeWidth = _ref$strokeWidth === void 0 ? (cov_2puq3ppw12.b[0][0]++, DefaultValue.strokeWidth) : _ref$strokeWidth,
      type = _ref.type,
      color = _ref.color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? (cov_2puq3ppw12.b[1][0]++, DefaultValue.size) : _ref$size,
      value = _ref.value,
      background = _ref.background,
      strokeLinecap = _ref.strokeLinecap;

  var className = (cov_2puq3ppw12.s[2]++, classnames(progressClass('circle', type, (cov_2puq3ppw12.b[2][0]++, isRTL()) && (cov_2puq3ppw12.b[2][1]++, 'rtl')), props.className));
  var r = (cov_2puq3ppw12.s[3]++, 100 - Math.ceil(strokeWidth / size * 100));
  var p = (cov_2puq3ppw12.s[4]++, Math.PI * 2 * r);
  var dasharray = (cov_2puq3ppw12.s[5]++, [p * (value / 100), p * (1 - value / 100)]);
  var style = (cov_2puq3ppw12.s[6]++, Object.assign({
    width: size,
    height: size
  }, props.style));
  var width = (cov_2puq3ppw12.s[7]++, (cov_2puq3ppw12.b[4][0]++, value === 0) && (cov_2puq3ppw12.b[4][1]++, strokeLinecap === 'round') ? (cov_2puq3ppw12.b[3][0]++, 0) : (cov_2puq3ppw12.b[3][1]++, strokeWidth * 2));
  var objColor = (cov_2puq3ppw12.s[8]++, (cov_2puq3ppw12.b[5][0]++, color) && (cov_2puq3ppw12.b[5][1]++, typeof color === 'object'));
  cov_2puq3ppw12.s[9]++;
  return (
    /*#__PURE__*/
    React.createElement("div", {
      className: className,
      style: style,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 37,
        columnNumber: 5
      }
    },
    /*#__PURE__*/
    React.createElement("svg", {
      viewBox: "0 0 200 200",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 38,
        columnNumber: 7
      }
    }, objColor ? (cov_2puq3ppw12.b[6][0]++,
    /*#__PURE__*/
    React.createElement("defs", {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 40,
        columnNumber: 11
      }
    },
    /*#__PURE__*/
    React.createElement("linearGradient", {
      id: "progress-linear",
      x1: "50%",
      x2: "50%",
      y1: "0%",
      y2: "100%",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 41,
        columnNumber: 13
      }
    }, analyzeColor(color).map(function (c) {
      cov_2puq3ppw12.f[1]++;
      cov_2puq3ppw12.s[10]++;
      return (
        /*#__PURE__*/
        React.createElement("stop", {
          key: c.pos,
          offset: c.pos,
          stopColor: c.color,
          __self: _this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 43,
            columnNumber: 17
          }
        })
      );
    })))) : (cov_2puq3ppw12.b[6][1]++, null),
    /*#__PURE__*/
    React.createElement("circle", {
      className: progressClass('background'),
      cx: "100",
      cy: "100",
      r: r,
      strokeWidth: strokeWidth * 2,
      fill: "transparent",
      style: {
        stroke: background
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 48,
        columnNumber: 9
      }
    }),
    /*#__PURE__*/
    React.createElement("circle", {
      className: progressClass('front'),
      cx: "100",
      cy: "100",
      r: r,
      fill: "transparent",
      style: {
        stroke: objColor ? (cov_2puq3ppw12.b[7][0]++, "url('#progress-linear')") : (cov_2puq3ppw12.b[7][1]++, color)
      },
      strokeDasharray: dasharray,
      strokeLinecap: strokeLinecap,
      strokeWidth: width,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 57,
        columnNumber: 9
      }
    })), (cov_2puq3ppw12.b[8][0]++, children) && (cov_2puq3ppw12.b[8][1]++,
    /*#__PURE__*/
    React.createElement("div", {
      className: progressClass('content'),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 69,
        columnNumber: 20
      }
    }, children)))
  );
}

cov_2puq3ppw12.s[11]++;
Circle.defaultProps = DefaultValue;
export default Circle;